import { MathExt } from "./math";

export class SmoothScroller {

    private static readonly _runningAnimations:Array<number> = new Array<number>();

    private static cancelAnimations(): void {
        this._runningAnimations.forEach(x => cancelAnimationFrame(x));
        this._runningAnimations.splice(0, this._runningAnimations.length);
    }

    private static scrollToTarget(ev: Event, elem: HTMLAnchorElement): void {
        const target = document.getElementById(elem.hash.slice(1));
        const wrapper = document.getElementById('wrapper');
        if ( target && wrapper ) {
            this.cancelAnimations();

            const elemsToScroll = document.querySelectorAll('html');
            const end = target.offsetTop + 10;
            const epsilon = 0.01;

            ev.preventDefault();
            elemsToScroll.forEach((elemToScroll) => {
                let stopId = 0;
                const start = elemToScroll.scrollTop;
                
                const direction = MathExt.sign(end - start);
                let t = 0.0;
                let next = start;

                const animationFunc = (time: number) => {
                    const offsetHeight = wrapper.offsetHeight;
                    const shouldStopScrolling = next >= offsetHeight && direction > 0
                        || next <= 0 && direction < 0;

                    if ( t >= 1.0 - epsilon || shouldStopScrolling ) {
                        cancelAnimationFrame(stopId);
                        return;
                    }
                    else {
                        elemToScroll.scrollTop = next;
                        t += 0.04;
                        const blend = MathExt.parametricBlend(t);
                        next = start + (end - start) * blend;
                        stopId = window.requestAnimationFrame(animationFunc);
                    }
                };
                this._runningAnimations.push(window.requestAnimationFrame(animationFunc));
            });
        }
    }

    private static linkClicked(ev: Event): void {
        const elem = ev.target as HTMLAnchorElement;

        const sanitizedTargetPath = location.pathname.replace(/^\//, '');
        const sanitizedCurrentPath = elem.pathname.replace(/^\//, '');

        if ( sanitizedTargetPath === sanitizedCurrentPath
            && location.hostname === elem.hostname )
            this.scrollToTarget(ev, elem);
    }

    static initialize() {
        const linkQuery = 'a[href*="#"]:not([href="#"]):not([href="#0"])';
        document.querySelectorAll(linkQuery).forEach((x: Element) => {
            (x as HTMLElement).onclick = (ev: Event) => this.linkClicked(ev);
        });
    }

}